const path = "legal_id_type."

export const getLegalIdTypeOptions = (t: any) => {
    const legalIdTypeOptions = [
        { value: "DNI", text: t(path + "dni") },
        { value: "PP", text: t(path + "passport") },
        { value: "DL", text: t(path + "driver_license") },
    ];
    return legalIdTypeOptions;
}